import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "ai-enterprise-digital-transformation-india-new-jersey-2026": {
    id: 1,
    title: "How AI Is Redefining Enterprise Digital Transformation in 2026 ",
    category: "AI Enterprise",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "August 25, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Artificial Intelligence (AI) is rapidly transforming how businesses approach digital innovation in 2026. TechProjects is at the forefront of this transformation, helping organizations explore modern technology solutions across India and New Jersey.",
    content: [
      {
        type: "heading2",
        text: "From India to New Jersey: How AI Is Redefining Enterprise Digital Transformation in 2026",
      },
      {
  type: "paragraph",
  text: 'Artificial Intelligence (AI) is rapidly transforming how businesses approach digital innovation in 2026. TechProjects is at the forefront of this transformation, helping organizations explore modern technology solutions across India and New Jersey. As demand for AI-powered business solutions continues to grow, <a href="https://techprojects.com/services/dst" class="text-blue-600 hover:text-blue-800 font-semibold">digital transformation companies in New Jersey</a> are playing an important role in helping enterprises modernize operations, improve customer experiences, strengthen cybersecurity, and make faster data-driven decisions.',
},

{
  type: "heading2",
  text: "AI Is Accelerating Digital Transformation in India",
},
{
  type: "paragraph",
  text: "India has become a major hub for technology innovation and enterprise digital transformation. Businesses are adopting AI to automate repetitive processes, analyze large amounts of data, improve customer service, predict market trends, and support better decision-making.",
},
{
  type: "paragraph",
  text: "IT services companies, Global Capability Centers (GCCs), financial organizations, healthcare providers, manufacturers, and startups are increasingly integrating AI into their digital strategies.",
},
{
  type: "paragraph",
  text: "The major shift in 2026 is from AI experimentation to practical implementation. Companies are focusing on how AI can solve specific business challenges, reduce operational costs, improve productivity, and create better customer experiences.",
},

{
  type: "heading2",
  text: "New Jersey Businesses Are Embracing AI",
},
{
  type: "paragraph",
  text: "New Jersey has a growing technology ecosystem covering artificial intelligence, cybersecurity, digital health, fintech, data analytics, and other emerging technologies.",
},
{
  type: "paragraph",
  text: "Businesses are exploring AI-powered solutions for customer support, marketing, software development, business intelligence, fraud detection, workflow automation, and operational management.",
},
{
  type: "paragraph",
  text: "This is increasing demand for digital transformation companies in New Jersey that can help enterprises modernize their technology infrastructure and implement AI-driven solutions.",
},

{
  type: "heading2",
  text: "From Automation to Intelligent Operations",
},
{
  type: "paragraph",
  text: "Traditional digital transformation focused largely on converting manual processes into digital workflows. AI is taking this transformation further by enabling systems to analyze information, identify patterns, generate insights, and assist employees with complex decisions.",
},
{
  type: "paragraph",
  text: "Generative AI and AI-powered agents are also helping organizations automate knowledge-based tasks and improve interactions with enterprise applications.",
},
{
  type: "paragraph",
  text: "However, successful AI implementation requires more than adopting technology. Businesses need quality data, secure infrastructure, effective governance, employee training, and strong cybersecurity practices.",
},

{
  type: "heading2",
  text: "TechProjects and the India–New Jersey Technology Connection",
},
{
  type: "paragraph",
  text: '<a href="https://techprojects.com/" class="text-blue-600 hover:text-blue-800 font-semibold">TechProjects</a> represents the growing connection between technology expertise in India and business opportunities in New Jersey. Modern enterprises can benefit from technology capabilities covering AI, cloud modernization, data analytics, cybersecurity, software development, and enterprise digital transformation.',
},
{
  type: "paragraph",
  text: "For organizations evaluating digital transformation companies in New Jersey, having access to experienced technology professionals and scalable digital solutions can make the transition to AI-powered operations more efficient.",
},
{
  type: "paragraph",
  text: "Cross-border technology partnerships can also help businesses combine India's large technology talent pool with the enterprise requirements of the New Jersey market.",
},

{
  type: "heading2",
  text: "Key AI Priorities for Businesses in 2026",
},
{
  type: "paragraph",
  text: "Organizations planning an AI-driven digital transformation strategy should focus on five important priorities:",
},

{
  type: "heading3",
  text: "1. Build a Strong Data Foundation",
},
{
  type: "paragraph",
  text: "Reliable, secure, and well-organized data is essential for effective AI implementation.",
},

{
  type: "heading3",
  text: "2. Identify High-Value AI Use Cases",
},
{
  type: "paragraph",
  text: "Businesses should prioritize AI projects that deliver measurable improvements in productivity, revenue, customer experience, or cost savings.",
},

{
  type: "heading3",
  text: "3. Strengthen Cybersecurity",
},
{
  type: "paragraph",
  text: "AI adoption must be supported by strong security controls and responsible data management.",
},

{
  type: "heading3",
  text: "4. Upskill Employees",
},
{
  type: "paragraph",
  text: "Employees need the right knowledge and training to work effectively with AI-powered tools.",
},

{
  type: "heading3",
  text: "5. Measure Business Results",
},
{
  type: "paragraph",
  text: "Organizations should track ROI, productivity, operational efficiency, customer satisfaction, and other measurable outcomes.",
},

{
  type: "heading2",
  text: "The Future of Enterprise Digital Transformation",
},
{
  type: "paragraph",
  text: "AI is changing how businesses across India and New Jersey approach digital transformation. In 2026, successful organizations will focus less on simply adopting AI tools and more on integrating AI into their overall business strategies.",
},
{
  type: "paragraph",
  text: "The combination of AI, cloud computing, automation, data analytics, cybersecurity, and human expertise will create more intelligent, flexible, and competitive enterprises.",
},
{
  type: "paragraph",
  text: "With TechProjects as a technology-focused partner, businesses can explore modern digital transformation opportunities and prepare for an AI-driven future. As enterprises continue investing in intelligent technologies, digital transformation companies in New Jersey and technology providers in India will play an increasingly important role in shaping the next generation of enterprise innovation.",
},

{
  type: "heading2",
  text: "Frequently Asked Questions",
},

{
  type: "heading3",
  text: "1. What is AI-driven digital transformation?",
},
{
  type: "paragraph",
  text: "AI-driven digital transformation is the process of using artificial intelligence, automation, cloud computing, data analytics, and modern digital technologies to improve business operations, customer experiences, decision-making, and overall efficiency.",
},

{
  type: "heading3",
  text: "2. How is AI changing digital transformation in 2026?",
},
{
  type: "paragraph",
  text: "AI is moving digital transformation from traditional automation toward intelligent decision-making and AI-powered workflows. Businesses are using generative AI, AI agents, predictive analytics, and automation to improve productivity, reduce costs, and develop new products and services.",
},

{
  type: "heading3",
  text: "3. What are the benefits of AI for enterprise digital transformation?",
},
{
  type: "paragraph",
  text: "Key benefits include increased productivity, improved decision-making, reduced operational costs, better customer relationships, enhanced products and services, and greater innovation. Deloitte reports productivity and efficiency as leading benefits of enterprise AI adoption.",
},

{
  type: "heading3",
  text: "4. How can businesses successfully implement AI in digital transformation?",
},
{
  type: "paragraph",
  text: "Businesses should start with clear business objectives and high-value use cases, then establish strong data and technology foundations, cybersecurity controls, AI governance, employee training, and measurable ROI. Moving from small pilots to scalable production systems is also critical.",
},

{
  type: "heading3",
  text: "5. How can digital transformation companies in New Jersey help businesses adopt AI?",
},
{
  type: "paragraph",
  text: "Digital transformation companies in New Jersey can help businesses assess their technology readiness, modernize applications and infrastructure, integrate AI and automation, improve data management, strengthen cybersecurity, and develop scalable digital strategies. Companies such as TechProjects can help organizations connect technology capabilities across India and New Jersey to support AI-driven enterprise transformation.",
},
      

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["ai-enterprise-digital-transformation-india-new-jersey-2026"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
          case "table":
  return (
    <div key={index} className="overflow-x-auto mb-6">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            {section.headers.map((header, i) => (
              <th
                key={i}
                className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-900"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {section.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="border border-gray-300 px-4 py-3 text-gray-700"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Artificial Intelligence (AI) is rapidly transforming how businesses approach digital innovation in 2026. TechProjects is at the forefront of this transformation, helping organizations explore modern technology solutions across India and New Jersey.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
